import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import Link from "next/link";
import React, { useId, useState } from "react";

const Academics = ({ isAcadenicOpen, setIsAcadenicOpen, handleX }: {
    isAcadenicOpen: boolean,
    setIsAcadenicOpen: (val: boolean) => void,
    handleX: () => void
}) => {
    const [hoverPrograme, setHoverPrograme] = useState<string | null>(null);
    const programes = [
        {
            id: useId(),
            children: [
                {
                    id: useId(),
                    title: "B.Sc. (Hons) in SOFTWARE ENGINEERING",
                    description: `Software engineering is central to the success of most modern businesses. This broad-based course covers the entire software engineering cycle, giving you the vocational skills, you need to take on specialist roles, from developer or programmer to IT technical support.`,
                    route: "/courses/bsc-software-engineering"
                },
                {
                    id: useId(),
                    title: "B.Sc. (Hons) in BUSINESS MANAGEMENT",
                    description: `This course equips you with the knowledge, skills and professional competency to work confidently as a manager in a digitally dependent business environment. It builds your understanding and practical skills in general business management subjects such as strategy, policy design, innovation and entrepreneurship while exploring the business practices reshaping current business models.`,
                    route: "/courses/bsc-business-management"
                },
            ],
        },
        {
            id: useId(),
            children: [
                {
                    id: useId(),
                    title: "B.Sc. (Hons) BM with Business Analytics",
                    description: `This program combines core business management principles with advanced analytics skills. Students learn to leverage data-driven insights for strategic decision-making, developing expertise in statistical analysis, data visualization, and predictive modeling while building strong foundations in business strategy and operations.`,
                    route: "/courses/bsc-business-management-business-analytics"
                },
                /* {
                    id: useId(),
                    title: "BSC (Hons) in BUSINESS MANAGEMENT",
                    description: `This course equips you with the knowledge, skills and professional competency to work confidently as a manager in a digitally dependent business environment. It builds your understanding and practical skills in general business management subjects such as strategy, policy design, innovation and entrepreneurship while exploring the business practices reshaping current business models.`,
                    route: "/courses/business-management"
                }, */
                {
                    id: useId(),
                    title: "B.Sc. (Hons) BM with Digital Marketing",
                    description: `This program equips students with the knowledge, skills, and professional competence to succeed as managers in digitally driven business environments. It builds strong foundations in core management areas such as strategy, policy design, innovation, and entrepreneurship, while examining the business practices shaping modern organizations.`,
                    route: "/courses/bsc-business-management-digital-marketing"
                },
            ],
        },
    ];

    const handleAcademicsLinkClick = () => {
        // setIsAcadenicOpen(false);
        document.body.style.overflow = "";
    };

    return (
        <section
            // md:h-[calc(100vh_-_6.25rem)] 
            className={`bg-white text-black absolute xl:top-[6.25rem] md:top-[4.25rem] top-[3.25rem] h-screen z-[2] block left-0 w-full overflow-y-auto
        ${isAcadenicOpen ? "visible " : "invisible"}
        `}
            style={{
                transform: isAcadenicOpen ? "translate(0)" : "translate(0, -100vh)",
                transition:
                    "transform 0.35s ease-in 0.15s, background-color 0.15s ease-in, visibility 0.5s ease-in",
            }}
        >
            <div className={`pb-[5.625rem] bg-white`}>
                <header
                    className={`p-0 h-[12.5rem] relative flex flex-col items-center justify-center w-full overflow-hidden`}
                >
                    <span
                        className={`bg-transparent p-[0_3.125rem] absolute top-0 left-0 flex flex-row items-center w-full h-[3.75rem] z-[3]`}
                    >
                        <button
                            className="bg-white rounded-full h-[2.5rem] p-[1.125rem_0_0] absolute right-[1.25rem] top-[1.25rem] w-[2.5rem] border-none cursor-pointer text-[0.875rem] leading-[0.875rem] overflow-hidden
             flex items-center justify-center
              "
                            //text-[#A31F34]
                            onClick={() => {
                                handleX();
                            }}
                        >
                            <X
                                // className="size-[15.4]"
                                // width={15.4}
                                // height={15.4}
                                style={{
                                    transition: "opacity 0.25s ease",
                                    translate: "0 -0.5rem",
                                }}
                            />
                        </button>
                    </span>
                    <h2
                        className={`text-[2.75rem] opacity-[1] leading-[3.4375rem] 
                            p-[0.9375rem_1.25rem] font-[100] text-[#272727] 
                            max-w-[70%] m-0 bg-white text-center z-[2] font-semibold`}
                    >
                        {hoverPrograme ? hoverPrograme : " Which program is right for you?"}
                    </h2>
                    <span
                        className={`absolute block top-0 left-0 w-full h-full z-[1]
                before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-[rgba(15,_63,_130,_0.5)] before:z-[2]
                `}
                        style={{
                            transition: "background-color 0.5s ease 0.5s",
                        }}
                    >
                        <img
                            src="/academics-overlay-default.png.webp"
                            loading="lazy"
                            width={1500}
                            height={500}
                            className="absolute top-1/2 left-1/2 min-w-full min-h-full z-[1] block max-w-full"
                            style={{
                                transform: "translate(-50%, -50%)",
                            }}
                        />
                    </span>
                </header>

                <div
                    className={cn(
                        `xl:max-w-[112.5rem] xl:m-[0_auto]`,
                        `md:flex md:flex-row`
                    )}
                >
                    <div className={cn(
                        /*    `max-w-[112.5rem] m-[0_auto] md:flex md:flex-row justify-center`,
                           `p-[1.25rem_1.25rem_0.625rem]` */
                        `xl:flex xl:w-full xl:p-[2.5rem_0_2.5rem_5rem]`,
                        `md:w-[51.2%] md:p-[2.1875rem_2.0625rem_1.875rem_3.125rem]`,
                        `p-[1.25rem_1.25rem_0.625rem]`
                    )}>
                        {programes.map((program) => {
                            return (
                                <div
                                    key={program.id}
                                    className={cn(
                                        `xl:w-full xl:p-[0_1.875rem_0_1.25rem] 
                                        md:pl-[1.25rem]
                                        md:border-l-[0.0625rem] md:border-l-[#EDEDED]`
                                    )}
                                >
                                    {program.children.map((child) => {
                                        return (
                                            <div key={child.id} className={cn(
                                                `pb-[1.25rem]`
                                            )}>
                                                <Link
                                                    href={child.route}
                                                    className={cn(
                                                        `md:text-[1rem] md:leading-6
                                                        text-[0.875rem] leading-6
                                                        transition-[color_0.25s_ease] hover:text-[#A31F34]`
                                                    )}
                                                    style={{
                                                        transform: "translateZ(0)",
                                                        backgroundImage: `linear-gradient(to top, transparent 0.125rem, #A31F34 0.125rem, #A31F34 0.1875rem, transparent 0.1875rem)`,
                                                    }}
                                                    onMouseEnter={() => setHoverPrograme(child.title)}
                                                    onMouseLeave={() => setHoverPrograme(null)}
                                                    onClick={() => {
                                                        setIsAcadenicOpen(false)
                                                        handleAcademicsLinkClick()
                                                    }}
                                                >
                                                    {child.title}
                                                </Link>
                                                <p
                                                    className={cn(
                                                        `md:text-[0.875rem] md:leading-[1.375rem] md:mt-[0.625rem]
                                                        text-[0.75rem] leading-[1.0875rem] m-[0.75rem_0_0]
                                                        `
                                                    )}
                                                >
                                                    {child.description}
                                                </p>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* <footer
                    className={`p-[0.9375rem_0] bg-[url(/svgs/dot-black.svg)] bg-repeat flex flex-row items-center justify-center w-full h-auto`}
                    style={{ backgroundSize: "0.375rem" }}
                >
                    <Link
                        href={"/events"}
                        className={`text-[0.875rem] hover:text-[#A31F34] leading-[0.875rem] p-[1.125rem_3.125rem] font-[100] bg-white inline-block tracking-[0.0125rem] text-[#272727]
            after:content-[url(/svgs/longarrowright-red.svg)] after:inline-block after:align-middle after:m-[-0.1875rem_0_0_1.25rem] after:text-[#A31F34] after:text-[1.125rem]
            after:leading-[0.875rem] after:transition-[transform_0.35s_ease-out] hover:after:translate-x-[0.625rem]
                `}
                    >
                        View Upcoming Events
                    </Link>
                </footer> */}
            </div>
        </section>
    );
};

export default Academics;